import { useNavigate } from 'react-router-dom';

import useStateHandler from '@/hooks/useStateHandler';
import ArtworkImage from '@/shared-components/cards/components/ArtworkImage';
import CardHeader from '@/shared-components/cards/components/CardHeader';
import ArtworkRatingDisplayer from '@/shared-components/inputs/components/ArtworkRatingDisplayer';
import Utils from '@/utils';
import { hasRenderableRating } from '@/utils/activityContent';
import { resolveFollowState } from '@/utils/followState';

import './styles/ArtworkInlineTitle.css';
import './styles/CommunityRatingCard.css';

export default function CommunityRatingCard({ data, ratingUser }) {
  const navigate = useNavigate();
  const { cacheHandler } = useStateHandler();
  if (!hasRenderableRating(data)) {
    return null;
  }
  const isFollowing = resolveFollowState({ cacheHandler, userId: ratingUser?._id, imFollowing: ratingUser?.im_following });

  return (
    <>
      <div
        className={`community-rating-card__container ${isFollowing ? 'following' : ''}`}
        onClick={() => navigate(`/artwork/${data.rating_artwork.slug}`, {
          state: {
            from: true,
            artworkViewSource: {
              type: 'community',
              label: '',
            }
          }
        })}
      >
        <CardHeader
          image={ratingUser.user_image?.image_id}
          profileType={ratingUser.user_type}
          username={ratingUser.user_username}
          onUserClick={() => navigate(`/user/${ratingUser.user_username}`)}
          timeAgo={Utils.elapsedTime(new Date(data.createdAt).getTime())}
          subtitle={
            <>
              on <span className="artwork-inline-title">{data.rating_artwork.artwork_about.artwork_title}</span>
            </>
          }
        />

        <ArtworkImage
          image={data.rating_artwork.artwork_media.artwork_main_picture.image_id}
          imageClassName="community-rating-card__artwork-image"
          imageTemplateClassName="community-rating-card__artwork-image"
          // forceSmaller={300}
        />

        <div className="community-rating-card__ratings">
          <ArtworkRatingDisplayer
            className="community-rating-card__rating"
            category="Emotions"
            username={ratingUser.user_username}
            userRating={data.rating_values.emotions}
            myRating={data.my_rating.rating_values.emotions}
          />

          <ArtworkRatingDisplayer
            className="community-rating-card__rating"
            category="Style"
            username={ratingUser.user_username}
            userRating={data.rating_values.style}
            myRating={data.my_rating.rating_values.style}
          />

          <ArtworkRatingDisplayer
            className="community-rating-card__rating"
            category="Time travel"
            username={ratingUser.user_username}
            userRating={data.rating_values.time_travel}
            myRating={data.my_rating.rating_values.time_travel}
          />
        </div>
      </div>
    </>
  );
}
